// @flow
import React, { Component, PropTypes } from 'react';
import Tooltip from 'rc-tooltip';
import classnames from 'classnames';
import _ from 'lodash';
import type { RequestStates } from 'types/redux';
import type { Errors } from 'types/errors';
import { connect } from 'react-redux';
import ErrorsNotification from 'components/others/ErrorNotification';

type Props = {
  cohortGet: Function,
  cohortGetRequest: RequestStates,
  cohortGetErrors: Errors,

  resetErrorState: Function,

  setSimulationParams: Function,
}

type State = {
  searchCohortID: string,
};

const requestErrors = [
  'cohortGet',
];

class DisplayForm extends Component {
  static contextTypes = {
    store: PropTypes.object,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      searchCohortID: '',
    };
  }

  state: State;

  openCohortParams = () => {
    this.props.setSimulationParams(true);
  };

  render() {
    return (
      <div className="cohort-selection-panel map-sidebar-section">
        <h3 className="title section-title is-6">Cohort{' '}
          <Tooltip
            placement="right"
            trigger="hover"
            overlay={
              <span>
                Cohort drivers will only be able to receive<br />
                jobs created within the same cohort.
              </span>
            }
          >
            <i className="fa fa-question-circle" />
          </Tooltip>
        </h3>
        <div className="columns">
          <div className="column is-half">
            <form
              className="field has-addons"
              onSubmit={(event) => {
                event.preventDefault();
                this.props.cohortGet(this.state.searchCohortID);
                this.props.resetErrorState(requestErrors);
              }}
            >
              <input
                className="input control"
                type="text"
                placeholder="Enter a cohort ID"
                value={this.state.searchCohortID}
                aria-label="Cohort ID"
                onChange={(event) => {
                  this.setState({
                    searchCohortID: event.target.value,
                  });
                }}
              />
              <button
                className={classnames('button is-info control', {
                  'is-loading': this.props.cohortGetRequest.isPending,
                  'is-disabled': !this.state.searchCohortID,
                })}
                title="Select cohort"
                aria-label="Select cohort"
                type="submit"
              >
                <span className="icon" aria-hidden="true">
                  <i className="fa fa-arrow-right" />
                </span>
              </button>
            </form>
          </div>
          <div className="column is-half has-text-right">
            <button
              className="button"
              onClick={this.openCohortParams}
            >
              Run New Simulation
            </button>
          </div>
        </div>
        {!_.isEmpty(this.props.cohortGetErrors) &&
        <ErrorsNotification
          errors={this.props.cohortGetErrors}
          dismissible
          onClose={() => {
            this.props.resetErrorState('cohortGet');
          }}
        />
        }
      </div>
    );
  }
}

export default connect()(DisplayForm);




/** WEBPACK FOOTER **
 ** ./src/js/views/autosim/simulation/components/DisplayForm.jsx
 **/